import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import SeasonalEffects from './components/SeasonalEffects';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Movies from './pages/Movies';
import MovieDetail from './pages/MovieDetail';
import WatchMovie from './pages/WatchMovie';
import SeriesDetail from './pages/SeriesDetail';
import WatchEpisode from './pages/WatchEpisode';
import Profile from './pages/Profile';
import Subscriptions from './pages/Subscriptions';
import Support from './pages/Support';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminDashboard from './pages/admin/Dashboard';
import AdminMovies from './pages/admin/Movies';
import AdminSeries from './pages/admin/Series';
import AdminUsers from './pages/admin/Users';
import AdminTransactions from './pages/admin/Transactions';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <SeasonalEffects />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          <Route path="/movies" element={<Movies />} />
          <Route path="/movie/:id" element={<MovieDetail />} />
          <Route path="/watch/:id" element={<PrivateRoute><WatchMovie /></PrivateRoute>} />
          <Route path="/series/:id" element={<SeriesDetail />} />
          <Route path="/watch-series/:token" element={<PrivateRoute><WatchEpisode /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/support" element={<Support />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/payment-success" element={<PrivateRoute><div>Payment successful!</div></PrivateRoute>} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/movies" element={<AdminRoute><AdminMovies /></AdminRoute>} />
          <Route path="/admin/series" element={<AdminRoute><AdminSeries /></AdminRoute>} />
          <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
          <Route path="/admin/transactions" element={<AdminRoute><AdminTransactions /></AdminRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
